import { lazy } from "react";

// Lazy load components
const Users = lazy(() => import("../pages/users/users"));

// Branch routes
const Branch = lazy(() => import("../pages/branch/branch"));
const CreateBranch = lazy(
  () => import("../pages/branch/components/create/create"),
);
const EditBranch = lazy(() => import("../pages/branch/components/edit/edit"));

// Heating calc routes
const HeatingCalc = lazy(() => import("../pages/heating-calc/heating-calc"));

// Login routes
const Login = lazy(() => import("../pages/login/login"));

// Home banner routes
const HomeBanner = lazy(() => import("../pages/home-banner/home-banner"));
const CreateHomeBanner = lazy(
  () => import("../pages/home-banner/components/create/create"),
);
const EditHomeBanner = lazy(
  () => import("../pages/home-banner/components/edit/edit"),
);

// Useful tips routes
const UsefulTips = lazy(() => import("../pages/useful-tips/useful-tips"));
const CreateUsefulTip = lazy(
  () => import("../pages/useful-tips/components/create/create"),
);
const EditUsefulTip = lazy(
  () => import("../pages/useful-tips/components/edit/edit"),
);

// Partner routes
const Partner = lazy(() => import("../pages/partner/partner"));
const CreatePartner = lazy(
  () => import("../pages/partner/components/create/create"),
);
const EditPartner = lazy(() => import("../pages/partner/components/edit/edit"));

// Services routes
const Services = lazy(() => import("../pages/services/services"));
const CreateService = lazy(
  () => import("../pages/services/components/create/create"),
);
const EditService = lazy(
  () => import("../pages/services/components/edit/edit"),
);

// News routes
const News = lazy(() => import("../pages/news/news"));
const CreateNews = lazy(() => import("../pages/news/components/create/create"));
const EditNews = lazy(() => import("../pages/news/components/edit/edit"));
// delivery-fee routes
const DeliveryFee = lazy(() => import("../pages/delivery-fee"));
const CreateDeliveryFee = lazy(
  () => import("../pages/delivery-fee/components/create"),
);
const EditDeliveryFee = lazy(
  () => import("../pages/delivery-fee/components/edit"),
);
// About routes
const About = lazy(() => import("../pages/about/about"));

// Special offers routes
const SpecialOffers = lazy(
  () => import("../pages/special-offer/special-offers"),
);
const CreateSpecialOffer = lazy(
  () => import("../pages/special-offer/components/create/create"),
);
const EditSpecialOffer = lazy(
  () => import("../pages/special-offer/components/edit/edit"),
);
// Stories routes
const Stories = lazy(() => import("../pages/stories"));
const CreateStory = lazy(() => import("../pages/stories/components/create"));
const EditStory = lazy(() => import("../pages/stories/components/edit"));
// installment-conditions
const InstallmentConditions = lazy(
  () => import("../pages/installment-conditions"),
);
const CreateInstallmentCondition = lazy(
  () => import("../pages/installment-conditions/components/create"),
);
const EditInstallmentCondition = lazy(
  () => import("../pages/installment-conditions/components/edit"),
);

// Financial report routes
const FinancialReport = lazy(
  () => import("../pages/financial-report/financial-report"),
);
const CreateFinancialReport = lazy(
  () => import("../pages/financial-report/components/create/create"),
);
const EditFinancialReport = lazy(
  () => import("../pages/financial-report/components/edit/edit"),
);

// We are available routes
const WeAreAvailable = lazy(
  () => import("../pages/we-are-available/we-are-available"),
);
const CreateEditWeAreAvailable = lazy(
  () => import("../pages/we-are-available/components/create-edit/create-edit"),
);

// Become partner routes
const BecomePartner = lazy(
  () => import("../pages/become-partner/become-partner"),
);

// Subscribe news routes
const SubscribeNews = lazy(
  () => import("../pages/subscribe-news/subscribe-news"),
);

// Contact routes
const Contact = lazy(() => import("../pages/contact/contact"));

// Categories routes
const Categories = lazy(() => import("../pages/categories/categories"));
const EditCategory = lazy(
  () => import("../pages/categories/components/edit/edit"),
);
const CreateCategory = lazy(
  () => import("../pages/categories/components/create/create"),
);

// Product routes
const Products = lazy(() => import("../pages/products/products"));
const EditProduct = lazy(
  () => import("../pages/products/components/edit/edit"),
);
// Orders routes
const Orders = lazy(() => import("../pages/orders/orders"));
const OrderDetail = lazy(
  () => import("../pages/orders/components/detail/detail"),
);

export const heatingCalcRoutes = [
  {
    name: "Heating Calc",
    path: "/heating-calc",
    element: <HeatingCalc />,
    icon: "/icons/calculator.svg",
    group: "Sales",
  },
];

export const superAdminRoutes = [
  {
    name: "Users",
    path: "/users",
    element: <Users />,
    icon: "/icons/users.svg",
    group: "People",
  },
  {
    name: "Home Banner",
    path: "/home",
    icon: "/icons/home-banner.svg",
    element: <HomeBanner />,
    group: "Content",
    children: [
      {
        path: "home/:userId",
        element: <EditHomeBanner />,
      },
      {
        path: "home/create",
        element: <CreateHomeBanner />,
      },
    ],
  },
  {
    name: "Categories",
    path: "/categories",
    icon: "/icons/categories.svg",
    element: <Categories />,
    group: "Catalog",
    children: [
      {
        path: "categories/:editId",
        element: <EditCategory />,
      },
      {
        path: "categories/create",
        element: <CreateCategory />,
      },
      {
        path: "categories/create/:createId",
        element: <CreateCategory />,
      },
    ],
  },
  {
    name: "Products",
    path: "/product",
    icon: "/icons/product.svg",
    element: <Products />,
    group: "Catalog",
    children: [
      {
        path: "product/edit/:editId",
        element: <EditProduct />,
      },
      {
        path: "product/:categoriesId",
        element: <Products />,
      },
    ],
  },
  {
    name: "Orders",
    path: "/orders",
    element: <Orders />,
    icon: "/icons/service.svg",
    group: "Sales",
    children: [
      {
        path: "orders/:orderId",
        element: <OrderDetail />,
      },
    ],
  },
  {
    name: "installment-conditions",
    path: "/installment-conditions",
    element: <InstallmentConditions />,
    icon: "/icons/installment-conditions.svg",
    group: "Sales",
    children: [
      {
        path: "installment-conditions/:id",
        element: <EditInstallmentCondition />,
      },
      {
        path: "installment-conditions/create",
        element: <CreateInstallmentCondition />,
      },
    ],
  },
  {
    name: "About us",
    path: "/about",
    element: <About />,
    icon: "/icons/about.svg",
    group: "Content",
  },
  {
    name: "Useful tips",
    path: "/useful-tips",
    element: <UsefulTips />,
    icon: "/icons/useful-tips.svg",
    group: "Content",
    children: [
      {
        path: "useful-tips/:id",
        element: <EditUsefulTip />,
      },
      {
        path: "useful-tips/create",
        element: <CreateUsefulTip />,
      },
    ],
  },
  {
    name: "News",
    path: "/news",
    element: <News />,
    icon: "/icons/news.svg",
    group: "Content",
    children: [
      {
        path: "news/:id",
        element: <EditNews />,
      },
      {
        path: "news/create",
        element: <CreateNews />,
      },
    ],
  },
  {
    name: "Stories",
    path: "/stories",
    element: <Stories />,
    icon: "/icons/stories.svg",
    group: "Content",
    children: [
      { path: "stories/:id", element: <EditStory /> },
      { path: "stories/create", element: <CreateStory /> },
    ],
  },
  {
    name: "Partners",
    path: "/partner",
    element: <Partner />,
    icon: "/icons/partners.svg",
    group: "People",
    children: [
      {
        path: "partner/:id",
        element: <EditPartner />,
      },
      {
        path: "partner/create",
        element: <CreatePartner />,
      },
    ],
  },
  {
    name: "DeliveryFee",
    path: "/delivery-fee",
    element: <DeliveryFee />,
    icon: "/icons/delivery-fee.svg",
    group: "Sales",
    children: [
      {
        path: "delivery-fee/:id",
        element: <EditDeliveryFee />,
      },
      {
        path: "delivery-fee/create",
        element: <CreateDeliveryFee />,
      },
    ],
  },
  {
    name: "Branches",
    path: "/branch",
    element: <Branch />,
    icon: "/icons/location.svg",
    group: "Company",
    children: [
      {
        path: "branch/:id",
        element: <EditBranch />,
      },
      {
        path: "branch/create",
        element: <CreateBranch />,
      },
    ],
  },
  {
    name: "Services",
    path: "/services",
    element: <Services />,
    icon: "/icons/service.svg",
    group: "Catalog",
    children: [
      {
        path: "services/create",
        element: <CreateService />,
      },
      {
        path: "services/:id",
        element: <EditService />,
      },
    ],
  },
  {
    name: "Special offers",
    path: "/special-offers",
    element: <SpecialOffers />,
    icon: "/icons/special-offer.svg",
    group: "Catalog",
    children: [
      {
        path: "special-offers/create",
        element: <CreateSpecialOffer />,
      },
      {
        path: "special-offers/:id",
        element: <EditSpecialOffer />,
      },
    ],
  },
  {
    name: "Financial statements",
    path: "/financial-report",
    element: <FinancialReport />,
    icon: "/icons/financial-report.svg",
    group: "Company",
    children: [
      {
        path: "financial-report/create",
        element: <CreateFinancialReport />,
      },
      {
        path: "financial-report/:id",
        element: <EditFinancialReport />,
      },
    ],
  },
  {
    name: "Working hours",
    path: "/we-are-available",
    element: <WeAreAvailable />,
    icon: "/icons/working-hours.svg",
    group: "Company",
    children: [
      {
        path: "we-are-available/create-edit",
        element: <CreateEditWeAreAvailable />,
      },
    ],
  },
  {
    name: "Contacts",
    path: "/contact",
    element: <Contact />,
    icon: "/icons/contacts.svg",
    group: "Company",
  },
  {
    name: "Become A Partner",
    path: "/become-partner",
    element: <BecomePartner />,
    icon: "/icons/partner.svg",
    group: "People",
  },
  {
    name: "Subscribe to News",
    path: "/subscribe-news",
    element: <SubscribeNews />,
    icon: "/icons/followers.svg",
    group: "People",
  },
  ...heatingCalcRoutes,
];

// Admin routes include all routes for Super Admin (role 5) and Admin (role 4)
export const adminRoutes = [...superAdminRoutes];

// Limited Content User routes (role 6) - only Home Banner, News, and Special Offers
export const limitedContentUserRoutes = [
  {
    name: "Home Banner",
    path: "/home",
    icon: "/icons/home-banner.svg",
    element: <HomeBanner />,
    group: "Content",
    children: [
      {
        path: "home/:userId",
        element: <EditHomeBanner />,
      },
      {
        path: "home/create",
        element: <CreateHomeBanner />,
      },
    ],
  },
  {
    name: "News",
    path: "/news",
    element: <News />,
    icon: "/icons/news.svg",
    group: "Content",
    children: [
      {
        path: "news/:id",
        element: <EditNews />,
      },
      {
        path: "news/create",
        element: <CreateNews />,
      },
    ],
  },
  {
    name: "Special offers",
    path: "/special-offers",
    element: <SpecialOffers />,
    icon: "/icons/special-offer.svg",
    group: "Catalog",
    children: [
      {
        path: "special-offers/create",
        element: <CreateSpecialOffer />,
      },
      {
        path: "special-offers/:id",
        element: <EditSpecialOffer />,
      },
    ],
  },
];

// Public routes - accessible only when NOT authenticated
export const publicRoutes = [
  {
    path: "/login",
    name: "Login",
    element: <Login />,
    icon: "/icons/sign-in.svg",
  },
];
